import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { TrashListResponse } from '../model/response/trash-response';
import { TrashRestoreRequest } from '../model/request/trashRestore-request';

@Injectable({providedIn: 'root'})
export class TrashService {

  userUrl: string
  httpOptions: {};

  constructor(private http: HttpClient) {
    this.httpOptions = {};
    this.userUrl = enviroment.BASE_URL_API + '/user';

    let idToken = sessionStorage.getItem('idToken') || ""
    this.httpOptions = {
      headers: new HttpHeaders({  
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      })
    };

  }

  getTrashList(userID: string) : Observable<TrashListResponse[]> {
    return this.http.get<TrashListResponse[]>(this.userUrl +'/' + userID + '/garbage', this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<TrashListResponse[]>(`getTrashList`))
    );
  }

  trashRestore(userID: string , infoTrash: TrashRestoreRequest[] ) : Observable<HttpResponse<any>> {
    return this.http.put<TrashListResponse>(this.userUrl +'/' + userID + '/garbage/restore', infoTrash, { observe: 'response' });
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  trashPermanently(userID: string, vcuID: string): Observable<void> {
    let url = `${this.userUrl}/${userID}/vcu/${vcuID}/permanently`;
    return this.http.delete<void>(url, this.httpOptions).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  DeletePermanentlyItemGarbage(userID: string, itemID: string, type: string): Observable<void> {
    let url = `${this.userUrl}/${userID}/mapOrLogID/${itemID}?type=${type}`;
    return this.http.delete<void>(url, this.httpOptions).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // Exclusao definitiva (hard delete) de um PROJETO que esta na lixeira.
  trashPermanentlyProject(userID: string, projectID: string): Observable<void> {
    let url = `${this.userUrl}/${userID}/project/${projectID}/permanently`;
    return this.http.delete<void>(url, this.httpOptions).pipe(
      catchError((error) => throwError(() => error))
    );
  }
}
